import { split, ApolloLink } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'
import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { createClient } from 'graphql-ws'
import { BatchHttpLink } from '@apollo/client/link/batch-http'
import { isUpload, isSubscriptionOperation } from './helpers'
import { withAuth, getSubscriptionParams } from './auth'
import { RetryLink } from '@apollo/client/link/retry'

const graphqlUrl = import.meta.env.VITE_ENDPOINT_GRAPHQL
const subscriptionstUrl = import.meta.env.VITE_ENDPOINT_SUBSCRIPTIONS

const wsClient = createClient({
	url: subscriptionstUrl,
	connectionParams: getSubscriptionParams,
	retryAttempts: Infinity,
	shouldRetry: () => true
})

const webSocketLink = new GraphQLWsLink(wsClient)

const retryLink = withAuth.concat(new RetryLink({
	delay: { initial: 1000 },
	attempts: {
		max: 3,
		retryIf: (error, operation) => operation?.operationName !== 'getClosingsReport'
	}
}))

const batchLink = retryLink.concat(new BatchHttpLink({ uri: graphqlUrl }))
const uploadLink = retryLink.concat(createUploadLink({ uri: graphqlUrl }))

const requestLink = split(isSubscriptionOperation, webSocketLink, batchLink)
const terminalLink = split(isUpload, uploadLink, requestLink)

export default terminalLink
